import { createContext } from 'react'
import noop from 'lib/function/noop'

export type OfferDescriptionExpansionHandler = () => void

const OfferDescriptionInteractionContext = createContext<OfferDescriptionExpansionHandler>(noop)

export default OfferDescriptionInteractionContext
